import Settings from './SettingsPage';

export default Settings;
